// import { createSelector } from 'reselect';

export const getIsPutting = state => state.getIn(['consultationFee', 'isPutting']);
export const getErrMsg = state => state.getIn(['consultationFee', 'errMsg']);